package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_COMPANY_RESPONSIBLE_PERSON
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateCompanyResponsiblePersonRequestModel(
    val id: Long,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val dialCode: String
) : BaseRequestModel(api = UPDATE_COMPANY_RESPONSIBLE_PERSON)
